export const endpoint = {
  getLogin: "admin/adminLogin",
  changePassword: "admin/changePassword",
  resetPassword: "admin/resetPassword",
  verifyOtp: "admin/verifyOtp",
  adminForgotPassword: "admin/forgotPassword",
  getAdminProfile: "admin/getAdminProfile",

  getServices: "admin/services",

  getAllusers: "admin/getAllusers",
  /** GET ?page=&limit= — user contact form submissions */
  contactUs: "admin/contact-us",
  getUserDetails: "admin/getUserDetails",
  deleteUser: "admin/deleteUser",
  updateStatus: "admin/updateStatus",
  getEventsCreatedByUser: "admin/getEventsCreatedByUser",

  getEvent: "admin/getEvent",

  getAllEvents: "admin/getAllVendors",
  vendorDelete: "admin/updateVendorStatus",
  getVendorDetail: "admin/getVendorDetails",
  updateVendorCommission: "admin/updateVendorCommission",
  updateVendor: "admin/updateVendorStatus",
  getPendingVendorList: "admin/PendingVendorRequests",
  getEventById: "admin/getEventById",
  getPendingVendorDetails: "admin/getVendorDetails",
  vendorgetApprove: "admin/approveOrRejectVendorRequest",
  vednorDetails: "admin/getVendorprofile",

  logout: "admin/logout",
  getSubAdminList: "admin/getSubAdminList",
  moduleList: "admin/getModuleList",
  createRole: "admin/createRole",
  getRoleList: "admin/getRoleModuleWiseList",
  deleterole: "admin/deleteRole",
  subAdminRole: "admin/getRoleList",
  createSubAdmin: "admin/createSubAdminRole",
  getDashboarddata: "admin/getDashboardData",
  SubAdminView: "admin/viewSubAdmin",
  updateSubAdmin: "admin/updateSubAdmin",
  deleteSubAdmin: "admin/deleteSubAdmin",
  blockSubAdmin: "admin/blockUnblockSubAdmin",
  getRoleByid: "admin/getRoleModuleById",
  editRole: "admin/editRole",

  getFaq: "admin/getFaq",
  updateFaq: "admin/updateFaq",
  createFaq: "admin/createFaq",
  deleteFaq: "admin/deleteFaq",
  getCms: "admin/getCms",
  updateCms: "admin/updateCms",
  deleteUser: "admin/deleteUser",
  getServiceListings: "admin/service-listings",
  approveRejectServiceListing: (serviceId) =>
    `admin/service-listings/${serviceId}/approve-reject`,
  getEnquiry: "admin/enquiry",
  kamAssignedEnquiryList: "admin/enquiry/assigned",
  /** GET ?page=&limit=&kam_inquiry_tab=new|ongoing|closed|cancelled — KAM assigned package enquiries */
  kamAssignedPackageEnquiryList: "admin/package-enquiry/assigned",
  kamAssignedPackageEnquiryDetail: (enquiryId) =>
    `admin/package-enquiry/assigned/${encodeURIComponent(String(enquiryId))}`,
  /** GET — KAM dashboard aggregates (inquiries / bookings counts) */
  kamDashboardDetail: "admin/kam-dashboard-detail",
  /** GET ?page=&limit=&kam_booking_tab=new|ongoing|closed|cancelled — KAM assigned bookings */
  kamAssignedBookingList: "admin/booking/assigned",
  /** GET — KAM assigned booking by id (same path segment as list + id) */
  kamAssignedBookingDetail: (bookingId) =>
    `admin/booking/assigned/${encodeURIComponent(String(bookingId))}`,
  /** POST body: { kam_notes } — KAM note on assigned booking */
  kamBookingAddNotes: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/add-notes`,
  /** PUT body: { kam_notes } — update KAM note on booking */
  kamBookingEditNotes: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/edit-notes`,
  kamAssignedEnquiryDetail: (enquiryId) =>
    `admin/enquiry/${encodeURIComponent(String(enquiryId))}/assigned-detail`,
  /** POST body: { kam_notes } — KAM note on assigned enquiry */
  kamEnquiryAddNotes: (enquiryId) =>
    `admin/enquiry/${encodeURIComponent(String(enquiryId))}/add-notes`,
  /** PUT body: { kam_notes } — update existing KAM note */
  kamEnquiryEditNotes: (enquiryId) =>
    `admin/enquiry/${encodeURIComponent(String(enquiryId))}/edit-notes`,
  /** PUT body: { inquiry_status_for_KAM, cancel_reason? } — KAM inquiry status (path uses backend spelling "inquery") */
  kamEnquiryInqueryStatusForKam: (enquiryId) =>
    `admin/enquiry/${encodeURIComponent(String(enquiryId))}/inquery-status-for-kam`,
  /** PUT body: { inquiry_status_for_KAM, cancel_reason? } — KAM package enquiry status */
  kamPackageEnquiryInqueryStatusForKam: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/inquery-status-for-kam`,
  getCateringEnquiry: "admin/sample-record",
  /** GET full sample history for an inquiry (data[] — one object per sample round) */
  getSampleRecordByInquiryId: (inquiryId) => `admin/sample-record/${inquiryId}`,
  getSampleRecordDetails: (cartId) => `admin/sample-record/details/${cartId}`,
  assignKeyManager: (enquiryId) => `admin/enquiry/${enquiryId}/assign-key-manager`,
  assignKeyManagerToCatering: (enquiryId) => `admin/sample-record/sample/${enquiryId}/assign-key-manager`,

  rejectEnquiry: (enquiryId) => `admin/sample-record/${enquiryId}`,
  acceptEnquiry: (enquiryId) => `admin/sample-record/${enquiryId}`,
  /** PUT body: { sample_status, reject_reason } — update sampling status (ongoing / pending / complete) */
  updateSampleRecord: (recordId) => `admin/sample-record/${recordId}`,
  getKeyManagerList: "admin/getKeyManagerList",
  getBookings: "admin/booking",
  getCateringBooking:"admin/catering-booking-list",
  getCateringVendorList: "admin/getCateringVendorList",
  /** PUT body: { vendor_id } — assign catering vendor on booking */
  assignCateringBookingVendor: (bookingId) =>
    `admin/booking/${bookingId}/assign-vendor`,
  /** GET catering booking detail for admin view (packages, billing, customer, KAM, help_ticket) */
  getCateringBookingById: (bookingId) => `admin/catering-booking/${bookingId}`,
  getBookingById: (bookingId) => `admin/booking/${bookingId}`,
  /** PUT body: { key_manager_id } — assign / update KAM on a booking */
  assignKeyManagerToBooking: (bookingId) =>
    `admin/booking/${bookingId}/assign-key-manager`,
  /** PUT body: { booking_status, reject_reason? } e.g. reject + reason, or accept */
  updateBookingStatus: (bookingId) => `admin/booking/${bookingId}/status`,
  /** PUT body: { booking_task_status_for_KAM: pending|in_progress|completed|discarded, cancel_reason? } */
  bookingStatusForKam: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/status-for-kam`,
  /** PUT — mark other-service (non-catering) booking as complete from ongoing list */
  otherServiceBookingComplete: (bookingId) =>
    `admin/booking/${bookingId}/other-service-complete`,
  /** PUT — approve vendor-side reject flow for other-service booking */
  otherServiceReject: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/other-service-reject`,
  /** PUT body: { cancel_status: "admin_accept", ... } — admin accepts user cancellation request */
  bookingUserCancelReview: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/user-cancel-review`,
  /** PUT — process user-cancel refund (Cancelled orders detail) */
  bookingUserCancelRefund: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/user-cancel-refund`,
  /** PUT — process refund for vendor-reject flow (Vendor reject detail) */
  bookingRejectRefund: (bookingId) =>
    `admin/booking/${encodeURIComponent(String(bookingId))}/booking-reject-refund`,
  getBookingHistory: "admin/booking-history",
  getBookingHistoryDetail: (vendorId, bookingId) =>
    `admin/booking-history-detail?vendor_id=${vendorId}&booking_id=${bookingId}`,
  createTag: "admin/tags/",
  getTags: "admin/tags/",
  deleteTag: "admin/tags",
  updateTag: (tagId) => `admin/tags/${tagId}`,
  getLabels: "admin/labels",
  createLabel: "admin/labels",
  getCateringPackageManagementList: "/catering/package-management-list",
  /** GET ?page=&limit=&package_type_id=&package_tier_id=&status= — admin package list */
  getAdminPackages: "admin/packages",
  /** GET — tier options (Basic / Standard / Premium) */
  getPackageTiers: "admin/packages/helpers/package-tiers",
  /** GET ?page=&limit= — tag options for package add/edit */
  getAdminPackageTags: "admin/package-tags",
  /** GET — event type options for package add/edit and list filters */
  getPackageEventTypes: "admin/packages/helpers/event-types",
  getPackageServiceCategories: "admin/packages/helpers/service-categories",
  /** GET ?service_id=&searchText= — vendors for included services */
  getPackageHelperVendors: "admin/packages/helpers/vendors",
  /** GET — city list for package location */
  getCities: "cities",
  /** GET detail / PUT update / DELETE — admin package by id */
  getAdminPackageById: (packageId) =>
    `admin/packages/${encodeURIComponent(String(packageId))}`,
  /** PUT body: { status: 0 | 1 } — activate / deactivate package */
  updateAdminPackageStatus: (packageId) =>
    `admin/packages/${encodeURIComponent(String(packageId))}/status`,
  /** GET ?page=&limit=&inquiry_tab= — package customer enquiries */
  getAdminPackageEnquiries: "admin/package-enquiry",
  getAdminPackageEnquiryById: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}`,
  assignPackageEnquiryKeyManager: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/assign-key-manager`,
  /** PUT body: { inquiry_status: "ongoing" | "cancel" } */
  updatePackageEnquiryStatus: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/status`,
  swapPackageEnquiryVendor: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/swap-vendor`,
  /** PUT body: vendor_id, service_listing_id, service_price, admin_replacement_note */
  updatePackageEnquiryLineItem: (enquiryId, lineItemId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/line-items/${encodeURIComponent(String(lineItemId))}`,
  /** PUT body: { vendor_index } — KAM flags rejected vendor for admin replacement */
  kamFlagPackageEnquiryVendor: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/flag-vendor`,
  /** PUT body: { customer_inquiry_verified: boolean } — KAM verified customer contact */
  kamCustomerInquiryVerified: (enquiryId) =>
    `admin/package-enquiry/${encodeURIComponent(String(enquiryId))}/customer-inquiry-verified`,
  getCateringCuisine: "catering/cuisine",
  getCateringPresetList: "admin/catering-preset",
  getCateringPresetCategoryList: "admin/catering-preset-category",
  createCateringPresetCategory: "admin/catering-preset-category",
  updateCateringPresetCategory: (categoryId) =>
    `/catering-preset-category/${categoryId}`,
  createCateringPresetMenu: "admin/catering-preset-menu",
  getCateringPresetMenuList: "admin/catering-preset-menu",
  getCateringPresetMenuDetail: (menuId) => `admin/catering-preset-menu/${menuId}`,
  getCateringPresetMenuMasterFoodDetail: (presetTypeOrId) =>
    `admin/catering-preset-menu/master-food-detail/${presetTypeOrId}`,
  updateCateringPresetMenu: (menuId) => `admin/catering-preset-menu/${menuId}`,
  createCateringPresetMenuFoodItem: (menuId) =>
    `admin/catering-preset-menu/${menuId}/food-items`,
  addCateringPresetMenuFoodItem: (menuId, categoryId) =>
    `admin/catering-preset-menu/${menuId}/add-food-item/${categoryId}`,
  updateCateringPresetMenuFoodItem: (menuId, itemId) =>
    `admin/catering-preset-menu/${menuId}/food-items/${itemId}`,
  updateCateringPresetMenuQuantity: (menuId, categoryId) =>
    `admin/catering-preset-menu/${menuId}/update-quantity/${categoryId}`,
  deleteCateringPresetMenu: (menuId) => `admin/catering-preset-menu/${menuId}`,
  samplePrice: "admin/sample-price",
  getCustomMenuList: "admin/catering-custom-menu",
  createCustomMenuItem: "admin/catering-custom-menu",
  updateCustomMenuItem: (id) => `/catering-custom-menu/${id}`,
  deleteCustomMenuItem: (id) => `/catering-custom-menu/${id}`,

  getProducts: "admin/products",
  getProductById: (id) => `admin/products/${id}`,
  createProduct: "admin/products",
  updateProduct: (id) => `admin/products/${id}`,
  deleteProduct: (id) => `admin/products/${id}`,
  /** Admin shop products — GET ?page=&limit=&searchText=&status= */
  adminProductShopList: "admin/product/shop/list",
  /** Admin rent products — GET ?page=&limit=&searchText=&status= */
  adminProductRentList: "admin/product/rent/list",
  /** Admin shop product detail — GET ?id= */
  adminProductShopDetails: (id) =>
    `admin/product/shop/details?id=${encodeURIComponent(String(id))}`,
  /** Admin rent product detail — GET ?id= */
  adminProductRentDetails: (id) =>
    `admin/product/rent/details?id=${encodeURIComponent(String(id))}`,
  /** Approve / reject shop or rent product — POST ?id= body { type: "shop"|"rent", status: 1|3, reason? } */
  adminProductShopRentAcceptReject: (id) =>
    `admin/product/shopRent/acceptReject?id=${encodeURIComponent(String(id))}`,
  /** Shop parent categories (Categories tab list) — GET */
  adminProductParentCategories: "admin/product/getParentCategory",
  /** Shop sub categories of a parent — GET ?parent_category_id= */
  adminProductParentSubCategories: (parentCategoryId) =>
    `admin/product/getParentSubCategory?parent_category_id=${encodeURIComponent(
      String(parentCategoryId)
    )}`,
  /** Rent parent categories (Categories tab list) — GET */
  adminRentParentCategories: "admin/rent/rentParentCategory",
  /** Rent sub categories of a parent — GET ?parent_category_id= */
  adminRentParentSubCategories: (parentCategoryId) =>
    `admin/rent/rentParentSubCategory?parent_category_id=${encodeURIComponent(
      String(parentCategoryId)
    )}`,
  productBrands: "admin/product-brands",
  productBrandsParentCategories: "admin/product-brands/allParentCategory",
  updateProductBrand: (id) => `admin/product-brands/${id}`,
  deleteProductBrand: (id) => `admin/product-brands/${id}`,
  /** Rent channel — brand management */
  rentBrands: "admin/rent-brand",
  rentBrandsParentCategories: "admin/rent-brand/allParentCategory",
  updateRentBrand: (id) => `admin/rent-brand/${id}`,
  deleteRentBrand: (id) => `admin/rent-brand/${id}`,
  productTags: "admin/product-tags",
  updateProductTag: (id) => `admin/product-tags/${id}`,
  deleteProductTag: (id) => `admin/product-tags/${id}`,

  /** GET shop tax rules — query: parent_category_id, sub_category_id, category_id, page, limit */
  getShopTaxRule: "admin/getShopTaxRule",
  /** POST body: tax_rule_id, hsn_chapter, hsn_heading, min_price, max_price, gst_rate, change_reason */
  updateShopTaxRule: "admin/updateShopTaxRule",

  /** GET ?page=&limit=&search=&raised_by=USER|VENDOR — help / support tickets */
  userTicketList: "admin/helpTicket/userTicketList",
  /** GET optional ?raised_by=USER|VENDOR — ticket id in path */
  userTicketDetails: (ticketId) =>
    `admin/helpTicket/userTicketDetails/${encodeURIComponent(String(ticketId))}`,
  /** POST body: { ticket_id, status } e.g. `IN_PROGRESS` */
  updateTicketStatus: "admin/helpTicket/updateTicketStatus",
  /** POST body: { ticket_id, message } — admin reply on ticket */
  adminHelpTicketReply: "admin/helpTicket/adminReply",
  /** GET ?page&limit&search= — all customer disputes */
  adminDisputeList: "admin/dispute/list",
  /** GET ?page&limit&search= — disputes assigned to logged-in KAM */
  kamAssignedDisputeList: "admin/dispute/assigned",
  /** GET — dispute detail by id */
  adminDisputeDetail: (disputeId) =>
    `admin/dispute/detail/${encodeURIComponent(String(disputeId).trim())}`,
  /** PUT { kam_communicated, kam_notes } — KAM acknowledges vendor/customer coordination */
  adminDisputeKamAck: (disputeId) =>
    `admin/dispute/${encodeURIComponent(String(disputeId).trim())}/kam`,
  /** POST { dispute_id, message } */
  adminDisputeReply: "admin/dispute/adminReply",
  /** PUT { dispute_id, status } — OPEN | IN_PROGRESS | RESOLVED | CLOSED */
  adminDisputeUpdateStatus: "admin/dispute/updateStatus",
  /** PUT { action, notes, refund_amount? } — initiate_refund | reject_payment */
  adminDisputeMark: (disputeId) =>
    `admin/dispute/${encodeURIComponent(String(disputeId).trim())}/mark`,

  /** GET ?request_tab=&page=&limit=&search= — vendor payout disputes (admin token only) */
  adminPayoutRequestList: "admin/payout-request/list",
  /** GET — vendor payout dispute detail by request id */
  adminPayoutRequestDetail: (requestId) =>
    `admin/payout-request/detail/${encodeURIComponent(String(requestId).trim())}`,
  adminPayoutRequestUpdateStatus: "admin/payout-request/updateStatus",
  adminPayoutRequestReply: "admin/payout-request/adminReply",
  adminPayoutRequestMark: (requestId) =>
    `admin/payout-request/${encodeURIComponent(String(requestId).trim())}/mark`,

  /** POST — create shop coupon */
  createShopCoupon: "admin/createShopCoupon",
  /** GET ?page=&limit=&searchText=&lifecycle_status=&parent_category_id=&sub_category_id=&status= */
  getShopCoupons: "admin/getShopCoupons",
  /** GET shop coupon detail */
  getShopCoupon: (couponId) =>
    `admin/getShopCoupon/${encodeURIComponent(String(couponId))}`,
  /** GET top-card counts */
  getShopCouponStats: "admin/getShopCouponStats",
  /** POST body: { coupon_id, value, expires_at, usage_limit, min_cart_amount } */
  updateShopCoupon: "admin/updateShopCoupon",
  /** POST body: { coupon_id, status: 0|1 } */
  activeDeactiveShopCoupon: "admin/activeDeactiveShopCoupon",
  /** POST body: { coupon_id } */
  deleteShopCoupon: "admin/deleteShopCoupon",

  /** GET — shop product offer list (no search) */
  getShopOffers: "admin/getShopOffers",
  /** POST body: { offer_id, name, discount_type|type: flat|percent, value, starts_at?, expires_at?, status } */
  updateShopOffers: "admin/updateShopOffers",
  /** POST ?offer_id=&status=active|inactive — toggle offer live state */
  activeDeactiveShopOffer: (offerId, status) => {
    const p = new URLSearchParams({
      offer_id: String(offerId),
      status: String(status),
    });
    return `admin/activeDeactiveShopOffer?${p.toString()}`;
  },

  /** GET ?page=&limit=&status_group=pending|ongoing|completed|returned|rejected&search= */
  adminShopOrders: "admin/orders/shop",
  /** GET shop order detail */
  adminShopOrderDetail: (shopOrderId) =>
    `admin/orders/shop/${encodeURIComponent(String(shopOrderId).trim())}`,
  /** GET unified shop product detail (ecom order item view) */
  adminProductDetail: (productId) =>
    `admin/product/${encodeURIComponent(String(productId).trim())}`,
};
